import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import ContentSameSize from '../../../core/components/content-same-size';
import { Breakpoint } from '../../../types/breakpoint';
export default class ColoredHeaderCompareTable {
    static $containers = $('.js__colored-header-compare-table-wrapper');
    static init() {
        if (!this.$containers.length) {
            return;
        }
        this.$containers.each((index, container) => {
            const $container = $(container);
            const $slider = $container.find('.js__colored-header-compare-table-slider');
            if (!$slider.length) {
                return;
            }
            const sliderElement = $slider.get(0);
            if (!sliderElement) {
                return;
            }
            const desktopSlides = Number($slider.data('desktop-slides-count')) || 3;
            const mobileSlides = Number($slider.data('mobile-slides-count')) || 2;
            const nextEl = $container.find('.js__colored-header-compare-table-next').get(0) ?? undefined;
            const prevEl = $container.find('.js__colored-header-compare-table-prev').get(0) ?? undefined;
            const options = {
                modules: [Navigation],
                watchOverflow: true,
                slidesPerView: mobileSlides,
                spaceBetween: 0,
                navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
                breakpoints: {
                    [Breakpoint.lg]: {
                        slidesPerView: desktopSlides || 3,
                        spaceBetween: 0,
                    },
                },
                on: {
                    init: function () {
                        ContentSameSize.init();
                    },
                },
            };
            new Swiper(sliderElement, options);
        });
    }
}
